import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/contracts')({
  staticData: { breadcrumb: 'Contracts', breadcrumbKey: 'K_BREADCRUMB_CONTRACTS' },
});
